import { Box, Image, Text, useMediaQuery, Spacer } from '@chakra-ui/react';

const Experts = ({ data }) => {
  const [isLargerThan700] = useMediaQuery('(min-width: 800px)');

  if (data) {
    return (
      <Box
        maxW={720}
        display={isLargerThan700 ? 'flex' : 'unset'}
        flexWrap="wrap"
      >
        {data.map((client) => (
          <Box
            key={client.attributes.keyPersonName}
            p="1rem"
            flex={1}
            display="flex"
            flexDirection="column"
          >
            <Box
              h={'140px'}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Image
                maxW="100%"
                maxH="100%"
                src={client.attributes.keyPersonPicture.data.attributes.url}
                alt={client.attributes.keyPersonName}
              />
            </Box>
            <Text
              fontSize="1rem"
              textAlign="center"
              fontWeight="bold"
              mt="0.4rem"
            >
              {client.attributes.keyPersonName}
            </Text>
            <Text
              fontSize="1rem"
              textAlign="center"
              fontWeight="bold"
              mt="0.2rem"
            >
              Founder, {client.attributes.company}
            </Text>
            <Text
              p="0.5rem 0"
              margin="0"
              fontSize={'0.9rem'}
              whiteSpace="pre-wrap"
              fontWeight={'semibold'}
              lineHeight={1.7}
              marginBlockStart={'1em'}
              marginBlockEnd={'1em'}
            >
              {`"${client.attributes.expertQuote}"`}
            </Text>
          </Box>
        ))}
      </Box>
    );
  }
};

export default Experts;
